
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment",
      function () {
        return require("private-next-pages/payment/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment"])
      });
    }
  